module.exports = __webpack_public_path__ + "static/img/banner.8eacad44.png";